export default __webpack_public_path__ + "static/O0227-88f725fa50be82592ef1da64adf36d56.png";